import { Row, Col, Form } from 'react-bootstrap';
import { useState } from 'react';

import StationChainCanvas from './StationChainCanvas.js';


function StationChainViewer({ rootStations, stationTrees, stationData }) {
  // State to hold the selected station
  const [selectedStationId, setSelectedStationId] = useState(
  stationTrees ? Object.entries(stationTrees).reduce((longestKey, [key, array]) => 
    array.length > stationTrees[longestKey].length ? key : longestKey
  , Object.keys(stationTrees)[0]) : null
);

  if(!rootStations || !Array.isArray(rootStations) || rootStations.length < 1) {
  	return null;
  }

  // Handle station selection change
  const handleStationChange = (e) => {
    setSelectedStationId(e.target.value);
  };

  // Function to render station details
  const renderStationDetails = (station) => {
    // Perform any additional processing or formatting here
    console.log(stationData);

    if(stationTrees && stationTrees[station.stationId]) {
	    
	    let canvasData = [];
	    for(let measureStation of stationTrees[station.stationId]) {
	    	console.log(measureStation);
	    	let levelStation = stationData.find(s => s.stationId === measureStation.stationId) || {};
	    	console.log("=>",levelStation);
	    	
	    	let levelValue = isNaN(parseFloat(levelStation.currentHeight)) ? null : parseFloat(levelStation.currentHeight);
	    	let typicalRangeHigh = isNaN(parseFloat(levelStation.typicalRangeHigh)) ? null : parseFloat(levelStation.typicalRangeHigh);
	    	let hasLevel = !!levelStation && levelValue;
	    	let levelState = "missing";
	    	if(levelStation && levelValue && typicalRangeHigh) {
	    		if(levelValue <= typicalRangeHigh) {
	    			levelState = "normal"
	    		} else {
	    			levelState = "critical";
	    		}
	    	} else if(levelStation && levelValue && !typicalRangeHigh) {
	    		levelState = "noData";
	    	}

	    	let hasFlow = !!measureStation.flowMetricId;
	    	let flowValue = isNaN(parseFloat(levelStation.currentFlow)) ? null : parseFloat(levelStation.currentFlow);
	    	let typicalFlowHigh = isNaN(parseFloat(levelStation.typicalFlowHigh)) ? null : parseFloat(levelStation.typicalFlowHigh);
	    	let flowState = "missing";
	    	if(levelStation && flowValue && typicalFlowHigh) {
	    		if(flowValue <= typicalFlowHigh) {
	    			flowState = "normal";
	    		} else {
	    			flowState = "critical";
	    		}
	    	} else if(levelStation && flowValue && !typicalFlowHigh) {
	    		flowState = "noData";
	    	}
	    	console.log(hasFlow);

	    	canvasData.push({
	    		stationName: measureStation.stationName || levelStation.stationName || "Unknown Station",
	    		levelValue,
	    		hasLevel,
	    		levelState,
	    		hasFlow,
	    		flowValue,
	    		flowState
	    	})
	    }
	    
	    return (
	      <StationChainCanvas stations={canvasData} />
	    );	
    }
    
    return <span><b><i>Cannot render station details.<br />Please try again later.</i></b></span>;
  };

  return (
    <Row>
      <Col xs={12} className="bg-dark text-white d-flex align-items-center fm-rounded-box-top">
        <span className="mx-auto" style={{ textAlign: "center" }}>
          Catchment Status Visualisation
        </span>

        {/* Snap FMRainfallStation to the right */}
        {/*<FMRainfallStation style={{
          fontSize: "1.1em", 
          position: "absolute", 
          right: "10px", // Adjust distance from the right as needed
        }} />*/}
      </Col>

      <Col xs={12} className="fm-rounded-box-bottom">
        <Row>
          <Col xs={12} md={3}>
            <Row>
            	<Col xs={12}>Select an upstream source</Col>
            	<Col xs={12}>
		            <Form.Select value={selectedStationId} onChange={handleStationChange}>
		              {rootStations.map((station) => (
		                <option key={station.stationId} value={station.stationId}>
		                  {station.stationName}
		                </option>
		              ))}
		            </Form.Select>
		        </Col>
		        <Col xs={12}></Col>
		    </Row>
          </Col>

          <Col xs={12} md={9}>
            {/* Display selected station details */}
	          {rootStations
	            .filter(station => station.stationId === selectedStationId)
	            .map((station) => renderStationDetails(station))}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default StationChainViewer;
